import { MINNESOTA_LMI_FUNNEL_ID } from '~/funnels/minnesota-lmi/config';
import { PERCH_FUNNEL_ID } from '~/funnels/perch-energy/config';
import { isAbpProgram } from '~/services/fetch-funnel-configuration/perch-project-details';

/**
 * This whole file config is something that shouldn't really be in the funnel
 * and rather fetched from EP. For now, I'm just separarating the logic out here
 * to keep things cleaner.
 */

// Project Group IDs
const abpProjectGroupId = 1;
const nonAbpProjectGroupId = 2;
const minnesotaLmiProjectGroupId = 102;
const minnesotaLegacyProjectGroupId = 135;

// Utility IDs
const illinoisUtilityIds = [2269, 2441];
const mnUtilityIds = [2447]; // Xcel MN

/**
 * Determines the project group ID based on utility ID and funnel ID.
 *
 * The ABP program in Illinois has different requirements than Illinois's non block program.
 * We are going to manage non-block projects soon and are building a new funnel to support non ABP use cases.
 * For now, any time we have a user signup in an Illinois utility, they should be marked as ABP.
 * For the perch-energy funnel, the program is determined from projectSnapshotData.
 */
export const determineProjectGroup = (
  utilityId: number,
  funnelId: string | undefined,
  projectSnapshotData?: { programName?: string | null } | null,
) => {
  if (illinoisUtilityIds.includes(utilityId)) {
    if (funnelId === PERCH_FUNNEL_ID && projectSnapshotData == null) return null;
    if (funnelId === PERCH_FUNNEL_ID) {
      return isAbpProgram(projectSnapshotData) ? abpProjectGroupId : nonAbpProjectGroupId;
    }
    return funnelId === 'nonABP' ? nonAbpProjectGroupId : abpProjectGroupId;
  }
  // Oregon project group is resolved in EP from the VNM project (query param projectId).
  if (mnUtilityIds.includes(utilityId)) {
    if (funnelId === MINNESOTA_LMI_FUNNEL_ID) return minnesotaLmiProjectGroupId;
    // Currently we only have lmi funnel in perch, once we migrate the legacy minnesota funnel to perch, we should remove this and update accordingly.
    if (funnelId === PERCH_FUNNEL_ID) return minnesotaLmiProjectGroupId;

    return minnesotaLegacyProjectGroupId; // For all other funnels
  }
  return null;
};
